<template>
  <div class="relative bg-slate-50">
    <div class="mx-auto max-w-3xl px-8 py-8 lg:max-w-6xl lg:py-12">
      <div class="mb-8 md:mb-10 lg:mb-14 lg:flex lg:justify-between">
        <div>
          <h3
            class="mx-auto mb-3 px-0 font-sans text-2xl font-semibold text-gray-900 antialiased lg:mb-0 lg:text-3xl"
          >
            What people say
          </h3>
          <div class="max-w-lg lg:max-w-lg">
            <p class="mt-6 text-base text-gray-500 md:text-base lg:text-base">
              Our clients are happy to say that our product is the best in the
              industry and we are very happy to be a part of their carbon
              reducing success.
            </p>
          </div>
        </div>
        <div class="mt-5 lg:mt-0">
          <NuxtLink
            to="/"
            class="block w-full select-none rounded-md border-2 border-green-800/50 bg-green-700 px-5 py-3 text-center text-sm font-normal text-white hover:bg-green-800 active:bg-green-700 lg:w-auto lg:px-10 lg:py-4 lg:text-sm"
          >
            <span>Find out more</span>
          </NuxtLink>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-0 lg:grid-cols-3 lg:gap-6">
        <div
          class="mb-4 rounded-3xl bg-white px-5 py-5 hover:shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <figure>
            <div class="mb-3 lg:mb-8">
              <svg
                width="31"
                height="25"
                viewBox="0 0 31 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6394 25H29.2535V12.7622H23.9268C24.2178 11.014 24.9746 9.49883 26.1972 8.21678C27.4197 6.93473 29.0207 6.0606 31 5.5944V0C26.5756 0.932399 23.2282 2.91375 20.9577 5.94406C18.7455 8.97436 17.6394 12.8205 17.6394 17.4825V25ZM0 25H11.5268V12.7622H6.2C6.49108 11.014 7.24789 9.49883 8.47042 8.21678C9.69296 6.93473 11.2939 6.0606 13.2732 5.5944V0C8.90704 0.932399 5.58873 2.91375 3.31831 5.94406C1.1061 8.97436 0 12.8205 0 17.4825V25Z"
                  fill="#20484F"
                />
              </svg>
            </div>
            <blockquote
              class="text-lg font-light text-gray-900 lg:text-[1.3em]"
            >
              Zuno Carbon's team were very professional and did a great job,
              enabling us to run an online carbon footprint.
            </blockquote>
            <footer class="mt-14 lg:mt-28">
              <cite class="author font-semibold text-gray-900">Tom Parsons</cite>
              <br>
              <cite class="company text-gray-900">VP of Product</cite>
            </footer>
          </figure>
        </div>

        <div
          class="mb-4 rounded-3xl bg-white px-5 py-5 hover:shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <figure>
            <div class="mb-3 lg:mb-8">
              <svg
                width="31"
                height="25"
                viewBox="0 0 31 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6394 25H29.2535V12.7622H23.9268C24.2178 11.014 24.9746 9.49883 26.1972 8.21678C27.4197 6.93473 29.0207 6.0606 31 5.5944V0C26.5756 0.932399 23.2282 2.91375 20.9577 5.94406C18.7455 8.97436 17.6394 12.8205 17.6394 17.4825V25ZM0 25H11.5268V12.7622H6.2C6.49108 11.014 7.24789 9.49883 8.47042 8.21678C9.69296 6.93473 11.2939 6.0606 13.2732 5.5944V0C8.90704 0.932399 5.58873 2.91375 3.31831 5.94406C1.1061 8.97436 0 12.8205 0 17.4825V25Z"
                  fill="#20484F"
                />
              </svg>
            </div>
            <blockquote
              class="text-lg font-light text-gray-900 lg:text-[1.3em]"
            >
              Veridis is making it easier for consumers to offset their carbon
              emissions.
            </blockquote>
            <footer class="g:mt-28 mt-14">
              <cite class="author font-semibold text-gray-900">Claudia Winkleman</cite>
              <br>
              <cite class="company text-gray-900">Product Manager</cite>
            </footer>
          </figure>
        </div>

        <div
          class="mb-4 rounded-3xl bg-white px-5 py-5 hover:shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <figure>
            <div class="mb-3 lg:mb-8">
              <svg
                width="31"
                height="25"
                viewBox="0 0 31 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6394 25H29.2535V12.7622H23.9268C24.2178 11.014 24.9746 9.49883 26.1972 8.21678C27.4197 6.93473 29.0207 6.0606 31 5.5944V0C26.5756 0.932399 23.2282 2.91375 20.9577 5.94406C18.7455 8.97436 17.6394 12.8205 17.6394 17.4825V25ZM0 25H11.5268V12.7622H6.2C6.49108 11.014 7.24789 9.49883 8.47042 8.21678C9.69296 6.93473 11.2939 6.0606 13.2732 5.5944V0C8.90704 0.932399 5.58873 2.91375 3.31831 5.94406C1.1061 8.97436 0 12.8205 0 17.4825V25Z"
                  fill="#20484F"
                />
              </svg>
            </div>
            <blockquote
              class="text-lg font-light text-gray-900 lg:text-[1.3em]"
            >
              Thanks so much to the team at Zuno for building something truly
              fun to use, and excellently equipt.
            </blockquote>
            <footer class="g:mt-28 mt-14">
              <cite class="author font-semibold text-gray-900">Renata Salvatore</cite>
              <br>
              <cite class="company text-gray-900">Director of Design</cite>
            </footer>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialsSection',
}
</script>
